import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import { useCallback, useState } from "react";

import EmptyState from "@/components/Core/EmptyState";
import { useTranslate } from "@/hooks";
import { searchGames } from "@/services";
import { InfiniteGameList } from "@/views/Games/InfiniteGameList";

import { MIN_LENGTH, SectionTitle } from "./styles";

/**
 * Games: every game of the site, most played first, until the term is long enough to
 * search; then every game whose name has it.
 */
const CasinoResults = ({ query }: { query: string }) => {
  const t = useTranslate();
  const [total, setTotal] = useState<number | null>(null);
  const ready = query.length >= MIN_LENGTH;
  // An empty term asks the server for the whole catalogue, most played first.
  const term = ready ? query : "";

  const loader = useCallback(
    (page: number, limit: number) => searchGames(term, page, limit),
    [term],
  );
  const count = total !== null ? t("game.list.count", { count: total }) : null;
  // Keeps the line's height while the count loads.
  const title = ready ? count : [t("search.all-games"), count].filter(Boolean).join(" · ");

  return (
    <Stack gap={1.5}>
      <SectionTitle>{title || " "}</SectionTitle>
      {ready && total === 0 && (
        <EmptyState title="game.list.no-match-title" description="search.no-match-desc" />
      )}
      {/* Kept mounted while empty: it is what loads the next term. */}
      <Box sx={ready && total === 0 ? { display: "none" } : undefined}>
        <InfiniteGameList loader={loader} resetKey={term} limit={24} onTotalChange={setTotal} />
      </Box>
    </Stack>
  );
};

export default CasinoResults;
